import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTheme } from "@mui/material/styles";
import { useTopProductsBySubscriptions } from "../../hooks/useSubscriptions";
import { CircularProgress, Box } from "@mui/material";

const BarChart3 = ({ limit = 5 }) => {
  const theme = useTheme();
  const { data: topProductsData, isLoading, error } = useTopProductsBySubscriptions(limit);

  const labelColor = theme.palette.text.primary;
  const isDarkMode = theme.palette.mode === "dark";

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height={350}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !topProductsData?.data) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height={350}>
        <div style={{ color: labelColor }}>Failed to load top products data</div>
      </Box>
    );
  }

  const { products, counts, revenues } = topProductsData.data;

  const series = [
    {
      name: "Subscriptions",
      data: counts,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: "100%",
  background: "transparent",      
  toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: "end",
        horizontal: true,
        distributed: true,
        barHeight: "70%",
        columnWidth: "70%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: products,
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: true,
        style: {
          fontSize: "16px",
          fontWeight: "bold",
          colors: labelColor,
        },
      },
    },
    yaxis: {
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: true,
        style: {
          fontSize: "16px",
          fontWeight: "bold",
          colors: labelColor,
        },
      },
    },
    grid: {
      show: false,
    },
    colors: ["#3767b1", "#bb41bd", "#32bd40", "#dc2d2d", "#fee044"],
    tooltip: {
      theme: isDarkMode ? "dark" : "light",
      style: {
        fontSize: "16px",
        // fontFamily: "Arial, sans-serif",
      },
      y: {
        formatter: function (value, { dataPointIndex }) {
          const revenue = revenues[dataPointIndex];
          return `${value} subscriptions ($${revenue?.toLocaleString() || 0} revenue)`;
        },
      },
    },
    legend: {
      labels: {
        colors: labelColor,
      },
    },
  };

  return (
    <div style={{ height: "100%" }}>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default BarChart3;
